export const PRIORITY_COLORS = {
  critica: '#FF6B6B',
  alta:    '#FBBF24',
  media:   '#6C8EFF',
  baja:    '#4CAF82',
};

export const PRIORITY_LABELS = {
  critica: 'Crítica',
  alta:    'Alta',
  media:   'Media',
  baja:    'Baja',
};

export const TYPE_COLORS = {
  tarea:       { color: '#6C8EFF',  label: 'Tarea'       },
  reunion:     { color: '#A78BFA',  label: 'Reunión'     },
  decision:    { color: '#FBBF24',  label: 'Decisión'    },
  aprendizaje: { color: '#4CAF82',  label: 'Aprendizaje' },
  riesgo:      { color: '#FF6B6B',  label: 'Riesgo'      },
  otro:        { color: '#6B7A99',  label: 'Otro'        },
};

export const IMPACT_COLORS = {
  alto:  '#FF6B6B',
  medio: '#FBBF24',
  bajo:  '#4CAF82',
};

export const PROBABILITY_LABELS = {
  alta:  'Alta',
  media: 'Media',
  baja:  'Baja',
};

export const TASK_STATUS_LABELS = {
  pendiente:   'Pendiente',
  en_progreso: 'En progreso',
  bloqueada:   'Bloqueada',
  hecha:       'Hecha',
  cancelada:   'Cancelada',
};

export const TASK_STATUS_COLORS = {
  pendiente:   '#6C8EFF',
  en_progreso: '#FBBF24',
  bloqueada:   '#FF6B6B',
  hecha:       '#4CAF82',
  cancelada:   '#6B7A99',
};

export const RISK_STATUS_LABELS = {
  abierto:  'Abierto',
  mitigado: 'Mitigado',
  aceptado: 'Aceptado',
  cerrado:  'Cerrado',
};

export const CRITICALITY_COLORS = {
  C1: '#FF6B6B',
  C2: '#FBBF24',
  C3: '#6C8EFF',
  C4: '#4CAF82',
};

export const CONTEXT_TYPE_LABELS = {
  proyecto: 'Proyecto',
  tema: 'Tema',
};

export const CONTEXT_STATUS_LABELS = {
  activo: 'Activo',
  pausado: 'Pausado',
  cerrado: 'Cerrado',
};

export const DECISION_STATUS_LABELS = {
  pendiente: 'Pendiente',
  tomada: 'Tomada',
  descartada: 'Descartada',
};

export const WEEKLY_ITEM_TYPES = {
  urgente:     { label: 'Urgente',      color: '#FF6B6B' },
  importante:  { label: 'Importante',   color: '#FBBF24' },
  estrategico: { label: 'Estratégico',  color: '#6C8EFF' },
};

export const CONTEXT_COLORS = [
  '#6C8EFF', '#A78BFA', '#4CAF82',
  '#FBBF24', '#FF6B6B', '#38BDF8',
];

export const RESOURCE_TYPE_LABELS = {
  template:          { label: 'Template',            icon: '📄' },
  checklist:         { label: 'Checklist',           icon: '☑️' },
  context:           { label: 'Contexto relevante',  icon: '🔗' },
  estimation_detail: { label: 'Desglose estimación', icon: '⏱️' },
};
